import { Box, H2 } from '@bigcommerce/big-design';
import ClientType from './Fields/ClientType';
import OrderComments from './Fields/OrderComments';

export function OrderDetailsForm({ groups, customer, setCustomerInformation }) {
	return (
		<Box borderRadius="normal" padding="medium">
			<H2>Order Details</H2>
			<ClientType groups={groups} customer={customer} />
			<OrderComments
				customer={customer}
				setCustomerInformation={setCustomerInformation}
			/>
		</Box>
	);
}
